/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from '../../components/Spinner';
import Card from '../../components/Card';
import * as actionCreators from '../../root/actions';
import { PHONE_URL } from '../../api/endpoints';

export class Phone extends Component {
  state = {
    isSubmitting: false
  };

  render() {
    const { phone, app } = this.props.containers;
    // const classes = useStyles(style);

    return (
      <Card>
        <form onSubmit={e => this.onSubmit(e)}>
          {phone.get('isLoading') && app.get('isMobile') ? (
            <Spinner />
          ) : (
            this.renderView()
          )}
        </form>
      </Card>
    );
  }

  renderView() {
    return (
      <Fragment>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '15px !important' }}>
            Welcome to Thorne Lab
          </div>
          <button
            type="submit"
            fullWidth
            fixed
            style={{
              margin: '25px 0',
              color: '#FFF',
              fontSize: '18px',
              fontWeight: 'normal'
            }}
            onClick={this.props.onSigninClick}
          >
            Sign In
          </button>
          <button
            type="submit"
            fullWidth
            fixed
            style={{
              margin: '25px 0',
              color: '#FFF',
              fontSize: '18px',
              fontWeight: 'normal'
            }}
            onClick={this.props.onSignupClick}
          >
            Register
          </button>
        </div>
      </Fragment>
    );
  }

  componentDidMount() {
    this.props.checkIfMobile(); // if logging out, store resets, reInit mobile measurement
    const input = document.getElementsByTagName('input')[0];
    setTimeout(() => {
      if (input) input.value = '';
    }, 0);
  }

  onSubmit(e) {
    e.preventDefault();
    const { phone } = this.props.containers;

    if (this.state.isSubmitting || phone.get('value') === '') return;
    this.setState({ isSubmitting: true });

    const { apiRequest } = this.props;

    const request = {
      url: PHONE_URL,
      data: { phone: phone.get('value') },
      method: 'post'
    };

    const meta = {
      ignoreAuth: true,
      Component: 'Phone',
      ignoreErrorStatus: 404,
      onSuccess: (_result, meta) => {
        this.setState({ isSubmitting: false }, () => {
          if (meta.status === 200) {
            this.props.changeRoute({ route: '/passcode' });
          }
        });
      },
      onError: (error, meta) => {
        console.log(error);
        this.setState({ isSubmitting: false }, () => {
          if (meta.status === 404) this.props.changeRoute({ route: '/signup' });
        });
      }
    };

    apiRequest(request, meta);
  }
}

const mapStateToProps = state => {
  const { containers } = state;

  return {
    containers
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Phone);
